<template>
  <div class="columns is-variable is-2 input-group">
    <div class="column" :class="numberColumnClass">
      <card-number
        v-bind="{ classes }"
        @input="updateCardNumber"
        @valid="updateCardNumberValidity"
        @card="updateCardData"
        :placeholder="placeholder || 'Number on Card'"
        :label="false"/>
    </div>
    <div class="column">
      <card-expiry
        ref="expiry"
        v-bind="{ classes }"
        @input="updateCardExpiry"
        @valid="updateCardExiryValidity"/>
    </div>
    <div class="column">
      <card-code
        ref="code"
        v-bind="{ classes }"
        @input="updateCardCode"
        @valid="updateCardCodeValidity"
        :length="card.code ? card.code.size : 0"
        :placeholder="card.code ? card.code.name : false"/>
    </div>
  </div>
</template>

<script>
import * as props from '../mixins/props'

export default {

  mixins: [
    props.classes,
    props.placeholder
  ],

  props: {
    numberColumnClass: {
      type: String,
      default: 'is-6',
    },
    autoFocus: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    card: {},
    number: {
      number: '',
      valid: false,
    },
    code: {
      code: '',
      valid: false,
    },
    expiry: {
      date: '',
      valid: false,
    }
  }),

  mounted() {
    this.$emit('assign', this.$data)
  },

  methods: {
    focus(element) {
      if (this.autoFocus) {
        this.$refs[element].$el.querySelector('input').focus()
      }
    },
    updateCardData(data) {
      this.card = data
    },
    updateCardNumber(number) {
      this.number.number = number
    },
    updateCardNumberValidity(valid) {
      this.number.valid = valid
      if (valid) this.focus('expiry')
    },
    updateCardExpiry(date) {
      this.expiry.date = date
    },
    updateCardExiryValidity(valid) {
      this.expiry.valid = valid
      if (valid) this.focus('code')
    },
    updateCardCode(code) {
      this.code.code = code
    },
    updateCardCodeValidity(valid) {
      this.code.valid = valid
    },

    emitCard() {
      this.$emit('card', this.card)
    },
  },

  watch: {
    card: 'emitCard',
    number: 'emitCard',
    code: 'emitCard',
    expiry: 'emitCard',
  }

}
</script>
